(function () {
  'use strict';

  if (window.__ayamiSizeProfilePreselect) return;
  window.__ayamiSizeProfilePreselect = true;

  var APPLIED_ATTR = 'data-size-profile-applied';
  var REC_CLASS = 'size-profile-preselect__recommended';
  var LOCAL_KEY = 'ayami_size_profile';
  /* Fashion EU sizes commonly 30–70 */
  var EU_RE = /\b([3-6]\d)\b/;

  var state = {
    profile: null,
    sizeOptionNames: {},
    selectedOnce: false,
    userOverride: false,
  };

  function readJson(id) {
    var el = document.getElementById(id);
    if (!el || !el.textContent.trim()) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function readProfileFromLocal() {
    try {
      var raw = localStorage.getItem(LOCAL_KEY);
      if (!raw) return null;
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  function extractEu(value) {
    var s = String(value == null ? '' : value).trim();
    if (!s) return '';
    if (/^\d{2}$/.test(s)) return s;
    var cleaned = s.replace(/^eu\s*/i, '').trim();
    if (/^\d{2}$/.test(cleaned)) return cleaned;
    var match = s.match(EU_RE);
    return match ? match[1] : '';
  }

  function normalize(raw) {
    if (!raw || typeof raw !== 'object') return null;
    var eu = extractEu(raw.recommended_eu);
    if (!eu) return null;
    return { eu: eu, heightFit: raw.height_fit || null };
  }

  function matchesEu(candidate, eu) {
    return extractEu(candidate) === String(eu);
  }

  function isSizeNamed(text) {
    var t = String(text || '').toLowerCase();
    return (
      t.indexOf('size') >= 0 ||
      t.indexOf('talla') >= 0 ||
      t.indexOf('taille') >= 0 ||
      t.indexOf('maat') >= 0 ||
      t.indexOf('größe') >= 0 ||
      t.indexOf('grosse') >= 0 ||
      t.indexOf('taglia') >= 0 ||
      /^\s*eu\s*$/i.test(t)
    );
  }

  function valuesLookLikeEuSizes(values) {
    if (!values || !values.length) return false;
    var euCount = 0;
    for (var i = 0; i < values.length; i += 1) {
      if (extractEu(values[i])) euCount += 1;
    }
    return euCount >= Math.min(3, values.length) && euCount / values.length >= 0.6;
  }

  function loadSizeOptionNames() {
    var options = readJson('SizeProfileProductOptions');
    var names = {};
    if (Array.isArray(options)) {
      options.forEach(function (opt) {
        if (!opt) return;
        var name = String(opt.name || '');
        var values = (opt.values || []).map(function (v) {
          if (v && typeof v === 'object') return v.name || v.label || String(v);
          return v;
        });
        if (isSizeNamed(name) || valuesLookLikeEuSizes(values)) {
          names[name.toLowerCase()] = true;
          names[String(opt.position)] = true;
        }
      });
    }
    state.sizeOptionNames = names;
  }

  function optionNameMatches(el) {
    if (!el) return false;
    var dataName = String(el.getAttribute('data-option-name') || '').toLowerCase();
    if (dataName && state.sizeOptionNames[dataName]) return true;
    var name = String(el.getAttribute('name') || '');
    var lower = name.toLowerCase();
    if (isSizeNamed(lower)) return true;
    for (var key in state.sizeOptionNames) {
      if (!Object.prototype.hasOwnProperty.call(state.sizeOptionNames, key)) continue;
      if (key && lower.indexOf(key) === 0) return true;
    }
    return false;
  }

  function isSizeControl(el) {
    if (!el) return false;
    if (optionNameMatches(el)) return true;
    var name = String(el.getAttribute('name') || '').toLowerCase();
    var id = String(el.id || '').toLowerCase();
    var aria = String(el.getAttribute('aria-label') || '').toLowerCase();
    var dataOption = String(el.getAttribute('data-option') || '').toLowerCase();
    var dataOptionName = String(el.getAttribute('data-option-name') || '').toLowerCase();
    return (
      isSizeNamed(name) ||
      isSizeNamed(id) ||
      isSizeNamed(aria) ||
      isSizeNamed(dataOption) ||
      isSizeNamed(dataOptionName)
    );
  }

  function productScope() {
    var productForm = document.querySelector(
      'product-info, product-form, variant-selects, variant-radios, form[action*="/cart/add"], [data-product-form], .product-form'
    );
    if (!productForm) return document;
    return (
      productForm.closest('product-info, section, .product, main, .product-information') ||
      productForm
    );
  }

  function fieldsetLooksLikeSize(fieldset) {
    if (!fieldset) return false;
    var legend = fieldset.querySelector('legend, .form__label, .form__label span, label.form__label');
    var text =
      (legend && legend.textContent) ||
      fieldset.getAttribute('name') ||
      fieldset.getAttribute('data-option') ||
      '';
    if (isSizeNamed(text)) return true;
    var inputs = fieldset.querySelectorAll('input[type="radio"], option, [data-value]');
    var values = [];
    Array.prototype.forEach.call(inputs, function (node) {
      values.push(
        node.value ||
          node.getAttribute('data-value') ||
          node.getAttribute('data-option-value') ||
          node.textContent
      );
    });
    return valuesLookLikeEuSizes(values);
  }

  function findSizeSelects(root) {
    var selects = [];
    Array.prototype.forEach.call(root.querySelectorAll('select'), function (select) {
      var wrap = select.closest('.product-form__input, fieldset, variant-selects');
      var labelled = isSizeControl(select) || fieldsetLooksLikeSize(wrap);
      if (!labelled && select.id) {
        var labelEl = document.querySelector('label[for="' + cssEscape(select.id) + '"]');
        labelled = isSizeNamed(labelEl && labelEl.textContent);
      }
      var hasEu = Array.prototype.some.call(select.options || [], function (opt) {
        return !!extractEu(opt.value) || !!extractEu(opt.textContent);
      });
      if (hasEu && labelled) selects.push(select);
      else if (hasEu && valuesLookLikeEuSizes(Array.prototype.map.call(select.options, function (o) {
        return o.value || o.textContent;
      }))) {
        selects.push(select);
      }
    });
    return selects;
  }

  function findSizeRadios(root) {
    return Array.prototype.filter.call(
      root.querySelectorAll('input[type="radio"]'),
      function (input) {
        if (!extractEu(input.value)) return false;
        if (isSizeControl(input) || optionNameMatches(input)) return true;
        var fieldset = input.closest(
          'fieldset, .product-form__input, variant-radios, variant-selects, [data-option]'
        );
        return fieldsetLooksLikeSize(fieldset);
      }
    );
  }

  function findSizeButtons(root) {
    return Array.prototype.filter.call(
      root.querySelectorAll(
        'label, button, [role="radio"], [role="option"], .swatch-input__label, [data-value], [data-option-value]'
      ),
      function (btn) {
        if (btn.tagName === 'INPUT') return false;
        var input = btn.control || (btn.htmlFor ? document.getElementById(btn.htmlFor) : null);
        if (!input) input = btn.querySelector && btn.querySelector('input[type="radio"]');
        var value = String(
          (input && input.value) ||
            btn.getAttribute('data-value') ||
            btn.getAttribute('data-option-value') ||
            btn.getAttribute('value') ||
            btn.textContent ||
            ''
        );
        if (!extractEu(value)) return false;
        if (input && (isSizeControl(input) || optionNameMatches(input))) return true;
        if (isSizeControl(btn)) return true;
        var parent = btn.closest(
          'fieldset, .product-form__input, variant-radios, variant-selects, [data-option], ul'
        );
        return fieldsetLooksLikeSize(parent);
      }
    );
  }

  function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(value);
    }
    return String(value).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  }

  function markRecommended(el) {
    if (!el) return;
    el.classList.add(REC_CLASS);
    el.setAttribute('data-size-recommended', 'true');
    if (el.tagName === 'OPTION') {
      var select = el.parentElement;
      if (select && select.tagName === 'SELECT') {
        select.classList.add(REC_CLASS + '-select');
      }
    }
  }

  function clearRecommended(root) {
    Array.prototype.forEach.call(
      root.querySelectorAll('.' + REC_CLASS + ', .' + REC_CLASS + '-select, [data-size-recommended="true"]'),
      function (el) {
        el.classList.remove(REC_CLASS);
        el.classList.remove(REC_CLASS + '-select');
        el.removeAttribute('data-size-recommended');
      }
    );
  }

  function labelForInput(input) {
    if (!input) return null;
    if (input.id) {
      var byFor = document.querySelector('label[for="' + cssEscape(input.id) + '"]');
      if (byFor) return byFor;
    }
    return input.closest('label') || input.parentElement;
  }

  function setSelectValue(select, eu, shouldSelect) {
    if (!eu || !select) return false;
    var matched = null;
    Array.prototype.forEach.call(select.options || [], function (opt) {
      if (matchesEu(opt.value, eu) || matchesEu(opt.textContent, eu)) matched = opt;
    });
    if (!matched) return false;
    markRecommended(matched);
    markRecommended(select);
    if (shouldSelect && select.value !== matched.value) {
      select.value = matched.value;
      select.dispatchEvent(new Event('input', { bubbles: true }));
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
    return true;
  }

  function applyProfile(opts) {
    opts = opts || {};
    var profile = state.profile;
    if (!profile) return false;

    var root = document.querySelector('[data-size-profile-preselect]');
    if (!root || root.getAttribute('data-skip') === 'true') return false;

    var scope = productScope();
    clearRecommended(document);

    var shouldSelect =
      opts.forceSelect === true ||
      (!state.selectedOnce && !state.userOverride && opts.forceSelect !== false);

    var highlighted = false;
    var selected = false;

    findSizeSelects(scope).forEach(function (select) {
      if (setSelectValue(select, profile.eu, shouldSelect)) {
        highlighted = true;
        if (shouldSelect) selected = true;
      }
    });

    findSizeRadios(scope).forEach(function (input) {
      if (!matchesEu(input.value, profile.eu)) return;
      var label = labelForInput(input);
      markRecommended(label || input);
      input.setAttribute('data-size-recommended', 'true');
      highlighted = true;
      if (shouldSelect && !input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
        if (label) {
          try {
            label.click();
          } catch (e) {}
        }
        selected = true;
      } else if (input.checked) {
        selected = true;
      }
    });

    findSizeButtons(scope).forEach(function (btn) {
      var input = btn.control || (btn.htmlFor ? document.getElementById(btn.htmlFor) : null);
      if (!input) input = btn.querySelector && btn.querySelector('input[type="radio"]');
      var value = String(
        (input && input.value) ||
          btn.getAttribute('data-value') ||
          btn.getAttribute('data-option-value') ||
          btn.getAttribute('value') ||
          btn.textContent ||
          ''
      );
      if (!matchesEu(value, profile.eu)) return;
      markRecommended(btn);
      if (input) input.setAttribute('data-size-recommended', 'true');
      highlighted = true;
      var isSelected =
        (input && input.checked) ||
        btn.getAttribute('aria-checked') === 'true' ||
        btn.getAttribute('aria-selected') === 'true' ||
        btn.classList.contains('active') ||
        btn.classList.contains('selected') ||
        btn.classList.contains('is-selected');
      if (shouldSelect && !isSelected) {
        try {
          if (input && !input.checked) {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
          btn.click();
        } catch (e) {}
        selected = true;
      } else if (isSelected) {
        selected = true;
      }
    });

    if (highlighted || selected) {
      root.setAttribute(APPLIED_ATTR, profile.eu);
    }
    if (selected && shouldSelect) {
      state.selectedOnce = true;
    }
    return highlighted || selected;
  }

  function resolveProfile(root) {
    var fromAttr = root && root.getAttribute('data-recommended-eu');
    if (fromAttr && extractEu(fromAttr)) {
      return { eu: extractEu(fromAttr), heightFit: null };
    }
    return normalize(readJson('SizeProfilePreselectData')) || normalize(readProfileFromLocal());
  }

  function boot() {
    var root = document.querySelector('[data-size-profile-preselect]');
    if (!root) return;
    if (root.getAttribute('data-skip') === 'true') return;

    loadSizeOptionNames();
    state.profile = resolveProfile(root);
    if (!state.profile) return;

    var attempts = [0, 50, 150, 400, 800, 1500, 3000];
    attempts.forEach(function (delay) {
      window.setTimeout(function () {
        applyProfile({ forceSelect: !state.selectedOnce && !state.userOverride });
      }, delay);
    });

    document.addEventListener(
      'change',
      function (event) {
        var target = event.target;
        if (!target) return;
        var sizeRelated =
          (target.matches &&
            target.matches('input[type="radio"], select') &&
            (isSizeControl(target) || extractEu(target.value))) ||
          false;
        if (sizeRelated && extractEu(target.value) && extractEu(target.value) !== state.profile.eu) {
          state.userOverride = true;
        }
        window.setTimeout(function () {
          if (sizeRelated) {
            applyProfile({ forceSelect: false });
          } else {
            applyProfile({ forceSelect: !state.userOverride });
          }
        }, 80);
      },
      true
    );

    document.addEventListener(
      'click',
      function (event) {
        var target = event.target && event.target.closest
          ? event.target.closest('label, button, [role="radio"], [data-value]')
          : null;
        if (!target) return;
        var input = target.control || (target.htmlFor ? document.getElementById(target.htmlFor) : null);
        var value = (input && input.value) || target.getAttribute('data-value') || target.textContent;
        var eu = extractEu(value);
        if (!eu) return;
        if (eu !== state.profile.eu && (isSizeControl(input || target) || optionNameMatches(input || target))) {
          state.userOverride = true;
        }
        window.setTimeout(function () {
          applyProfile({ forceSelect: false });
        }, 80);
      },
      true
    );

    if (typeof MutationObserver !== 'undefined') {
      var scope = productScope();
      var timer = null;
      var observer = new MutationObserver(function () {
        if (timer) window.clearTimeout(timer);
        timer = window.setTimeout(function () {
          applyProfile({ forceSelect: !state.userOverride && !state.selectedOnce });
        }, 50);
      });
      try {
        observer.observe(scope, { childList: true, subtree: true });
      } catch (e) {}
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
